/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi.com Payments API
 * An API for Kiwi.com payments.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PaymentOrderViewGooglePayPaymentRequestTransactionInfoDisplayItemsInnerFromJSON, PaymentOrderViewGooglePayPaymentRequestTransactionInfoDisplayItemsInnerToJSON, } from './PaymentOrderViewGooglePayPaymentRequestTransactionInfoDisplayItemsInner';
/**
 * @export
 */
export const PaymentOrderViewGooglePayPaymentRequestTransactionInfoCheckoutOptionEnum = {
    CompleteImmediatePurchase: 'COMPLETE_IMMEDIATE_PURCHASE'
};
/**
 * @export
 */
export const PaymentOrderViewGooglePayPaymentRequestTransactionInfoTotalPriceStatusEnum = {
    Final: 'FINAL'
};
/**
 * Check if a given object implements the PaymentOrderViewGooglePayPaymentRequestTransactionInfo interface.
 */
export function instanceOfPaymentOrderViewGooglePayPaymentRequestTransactionInfo(value) {
    if (!('checkoutOption' in value) || value['checkoutOption'] === undefined)
        return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined)
        return false;
    if (!('currencyCode' in value) || value['currencyCode'] === undefined)
        return false;
    if (!('displayItems' in value) || value['displayItems'] === undefined)
        return false;
    if (!('totalPrice' in value) || value['totalPrice'] === undefined)
        return false;
    if (!('totalPriceLabel' in value) || value['totalPriceLabel'] === undefined)
        return false;
    if (!('totalPriceStatus' in value) || value['totalPriceStatus'] === undefined)
        return false;
    return true;
}
export function PaymentOrderViewGooglePayPaymentRequestTransactionInfoFromJSON(json) {
    return PaymentOrderViewGooglePayPaymentRequestTransactionInfoFromJSONTyped(json, false);
}
export function PaymentOrderViewGooglePayPaymentRequestTransactionInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'checkoutOption': json['checkout_option'],
        'countryCode': json['country_code'],
        'currencyCode': json['currency_code'],
        'displayItems': (json['display_items'].map(PaymentOrderViewGooglePayPaymentRequestTransactionInfoDisplayItemsInnerFromJSON)),
        'totalPrice': json['total_price'],
        'totalPriceLabel': json['total_price_label'],
        'totalPriceStatus': json['total_price_status'],
    };
}
export function PaymentOrderViewGooglePayPaymentRequestTransactionInfoToJSON(json) {
    return PaymentOrderViewGooglePayPaymentRequestTransactionInfoToJSONTyped(json, false);
}
export function PaymentOrderViewGooglePayPaymentRequestTransactionInfoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'checkout_option': value['checkoutOption'],
        'country_code': value['countryCode'],
        'currency_code': value['currencyCode'],
        'display_items': (value['displayItems'].map(PaymentOrderViewGooglePayPaymentRequestTransactionInfoDisplayItemsInnerToJSON)),
        'total_price': value['totalPrice'],
        'total_price_label': value['totalPriceLabel'],
        'total_price_status': value['totalPriceStatus'],
    };
}
